import { motion } from 'framer-motion';
import AnimatedActionButton from '../AnimatedActionButton';

const HeroSection = () => {
  const imgUrl = `${process.env.PUBLIC_URL}/group.jpg`;              // public/group.jpg
  const fallbackUrl = `${process.env.PUBLIC_URL}/images/group.jpg`;  // public/images/group.png

  return (
    <section className="w-full bg-white min-h-[100svh] flex items-center overflow-hidden">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-8 md:gap-10 items-center">
        {/* Left: Text (smaller + tighter) */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
        >
          <h1
            className="text-4xl md:text-5xl font-bold text-black leading-tight tracking-tight"
            style={{ fontFamily: 'Inter, sans-serif', margin: 0 }}
          >
            Recruit Smarter,<br />
            Hire Faster.
          </h1>

          <motion.p
            className="mt-4 text-base md:text-lg text-black/80 max-w-lg"
            style={{ fontFamily: 'Inter, sans-serif' }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.25, duration: 0.6, ease: 'easeOut' }}
          >
            We connect ambitious companies with exceptional tech talent across the UK, US, and MENA.
            From startups to hedge funds, our precision search process delivers high-impact hires with
            speed, integrity, and deep market insight.
          </motion.p>

          <div className="mt-6">
            <AnimatedActionButton
              text="Read More"
              as="a"
              href="#"
              className="py-3 rounded-xl text-base md:text-lg"
            />
          </div>
        </motion.div>

        {/* Right: Image – show full picture */}
        <motion.div
          className="
            relative w-full
            h-[320px] sm:h-[380px] md:h-[440px] lg:h-[500px] xl:h-[560px]
            max-w-[680px] justify-self-end
          "
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.35, duration: 0.6, ease: 'easeOut' }}
        >
          <img
            src={imgUrl}
            alt="Talent selection"
            className="
              absolute inset-0 w-full h-full
              object-contain   /* switch to object-cover if you want fill */
              rounded-2xl shadow-lg bg-white
            "
            loading="eager"
            decoding="async"
            draggable="false"
            onError={(e) => {
              if (e.currentTarget.src !== fallbackUrl) e.currentTarget.src = fallbackUrl;
            }}
          />
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
